
export class EscalaEvaluacionValor {
    escalaevaluacionvalorid: number = 0;
    escalaevaluacionid: number = 0;
    nombre: string = "";
    descripcion: string = "";
    valor: string = "";
    color: string = "";
    mostrarimagen: boolean = false;
    mostrartexto: boolean = false;
    mostrardescripcion: boolean = false;
    incluircalculo: boolean = false;
    activo: boolean = true;
    icono: string = "";
    file: any;

    constructor(init?: Partial<EscalaEvaluacionValor>) {
        Object.assign(this, init);
    }
}
